// ** React Imports
import { useEffect, useState } from 'react';

import { client } from 'src/utils/axios-client';
import {
    LeadScreenStore,
    LeadActivity,
    Lead,
    NextActivity,
    LeadAccountStore,
    ViewType,
    ActivityDialogStore,
    LeadCompanyStore,
    CompanyDialogStore,
    LeadSprintStore,
    SprintDialogStore,
    LeadActivityHistoryStore,
    ActivityHistoryDialogStore,
    LeadActivityMessagingStore,
} from 'src/stores/LeadStore';
import { leadEndpoints } from '../../../configs/endpoints';

// ** MUI Imports
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import CardContent from '@mui/material/CardContent';
import Tooltip from '@mui/material/Tooltip';
import Grid from '@mui/material/Grid';
import Link from '@mui/material/Link';
import _ from 'lodash';
import LeadDataFormater from './LeadDataFormater';
import Badge, { BadgeProps } from '@mui/material/Badge';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import RadialBarChart from '../../common/RadialBarChart';
import { previousDateDaysTooltip } from 'src/utils/date-utils';
import { previousDateDays } from 'src/utils/date-utils';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import TabPanel from '@mui/lab/TabPanel';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import React, { Fragment } from 'react';
import StandardSkeleton from '../../common/StandardSkeleton';
import HtmlView from '../../common2/Templating/HtmlView';

const DoActivityMessaging = () => {
    const messagingRecord = LeadActivityMessagingStore.useState((s) => s.record);
    const selectedLead = LeadScreenStore.useState((s) => s.selectedLead);
    const [value, setValue] = useState('');
    const [hasLoaded, setHasLoaded] = useState(false);

    useEffect(() => {
        const fetchActivityMessaging = async () => {
            setHasLoaded(false);
            const response = await client.get(
                leadEndpoints.getactivitymessaging.replace('{leadid}', '' + selectedLead?.id.toString()),
            );
            LeadActivityMessagingStore.update((s) => {
                s.record = response.data;
            });
            setHasLoaded(true);
        };
        if (selectedLead != null) fetchActivityMessaging();
    }, []);

    useEffect(() => {
        if (messagingRecord.templateTypeName == 'Phone Call') {
            setValue(messagingRecord.templateId);
        } else {
            if (messagingRecord.playbookLibraries.length > 0) {
                setValue(messagingRecord.playbookLibraries[0].name);
            }
        }
    }, [messagingRecord]);

    const handleChange = (event: React.SyntheticEvent, newValue: string) => {
        setValue(newValue);
    };

    if (hasLoaded) {
        return (
            <Box>
                <Grid container spacing={6}>
                    <Grid item xs={12}>
                        <Card variant="outlined">
                            <CardContent>
                                <Grid item xs={12} md={12} sx={{ alignItems: 'right' }} justifyContent={'flex-end'}>
                                    <Typography sx={{ fontSize: 20, color: 'CornflowerBlue' }} gutterBottom>
                                        Messaging
                                    </Typography>
                                </Grid>
                                <TabContext value={value}>
                                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                        <TabList onChange={handleChange} variant="scrollable" scrollButtons>
                                            {messagingRecord.templateTypeName == 'Phone Call' && (
                                                <Tab label="Call Script" value={messagingRecord.templateId} />
                                            )}
                                            {messagingRecord.playbookLibraries.map((record) => (
                                                <Tab label={record.name} value={record.name} key={record.id} />
                                            ))}
                                        </TabList>
                                    </Box>
                                    {messagingRecord.templateTypeName == 'Phone Call' && (
                                        <TabPanel value={messagingRecord.templateId}>
                                            <HtmlView html={messagingRecord.templateBody} />
                                        </TabPanel>
                                    )}
                                    {messagingRecord.playbookLibraries.map((record) => (
                                        <TabPanel value={record.name} key={record.id}>
                                            <HtmlView html={record.content} />
                                        </TabPanel>
                                    ))}
                                </TabContext>
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            </Box>
        );
    } else {
        return <StandardSkeleton />;
    }
};
export { DoActivityMessaging };
export default DoActivityMessaging;
